import React, { createContext, useState, useContext } from 'react';
const AppointmentsContext = createContext();

const AppointmentsProvider = ({ children }) => {
  const [appointments, setAppointments] = useState([]);
  
  return (
    <AppointmentsContext.Provider value={{ appointments, setAppointments }}>
      {children}
    </AppointmentsContext.Provider>
  );
};

const useAppointmentsContext = () => {
  return useContext(AppointmentsContext);
};

export { AppointmentsContext, AppointmentsProvider, useAppointmentsContext };